module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAMAAADTRh9nAAAAYFBMVEUAAACfn5+goKCgoKCcnJygoKCgoKCgoKCdnZ2goKCgoKCgoKCgoKCfn5+kpKSgoKCgoKCgoKCgoKChoaGfn5+hoaGgoKCgoKCgoKCgoKCgoKCgoKCioqKioqKioqKgoKCrNsR1AAAAH3RSTlMAVZn5BvTtTQnDvK1hRRMOzGxSPTMr59bSxrOjNyEWlJ2ZlgAAAHBJREFUGNN9zUkSgzAQQ1EZx2Z0SAgkYdT9b0mzwK5qqvjLt5CAwehWwFM3Ak2my3Ff+7xa713QtnjSqrGP46+k7ZT9t6KiNcmC40tuRNmcltvDpMckGq1sIYnW5BuSiZa0J6sCiDqTHYZvfVjSzIcdF08IQ7BeY1YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/float/go-top.png
// module id = oV/g
// module chunks = 33